// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__qQ6jN","discord":"styles_discord__1fUFW"};